import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Button, Menu, Switch, Box, Typography } from "@mui/material/";
import ProtectedComponent from "components/common/ProtectedComponent";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { show } from "store/reducers/notifications.reducer";
import customAxios from "lib/axios";

//Aqui metemos 3 parametros mas,
//1 -> El usuario que tiene abierta la sesion (supongo k lo podremos sacar)
//2 -> La info de si para ese usuario esta activo o no
//3 -> El handle para mostrar el mensage de error en caso que este activo en la API

const PopUpMenu = function ({
  id,
  anchor,
  handleClose,
  handleLoad,
  shared,
  userId,
  title,
  handleErrorStrategy,
  showConnector = true, // 👈 NUEVO
}) {
  const [t] = useTranslation("strategies");
  const [clientShared, setClientShared] = useState(shared);
  {
    /* FIN - Angel - 07\08\2023*/
  }
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const handleAPIActivation = async (event) => {
    setIsLoading(true);
    try {
      if (event.target.checked) {
        // Comprobar cuenta MT4/usuario
        const { data: resAccount } = await customAxios.get(
          `strategies/existsUserAccount`
        );

        if (resAccount && resAccount.exists) {
          const payload = {
            id,
            user_id: userId,
            name: title,
            more_info_url: "none",
            image: "none",
            operable: "Y",
            group: "-1",
            is_shared: shared,
          };

          // Insert en LIVE_ROBOTS_X_USER
          const res = await customAxios.post(`liveRobotsShared`, payload);
          if (res.status >= 200 && res.status < 300) {
            // const result = res.data; // si lo necesitas
            setClientShared(true);
          } else {
            setClientShared(false);
            console.error("Server error:", res.data);
          }
        } else {
          setClientShared(false);
          handleErrorStrategy(
            "Error al activar la estrategia, contacte con soporte!"
          );
        }
      } else {
        // Desactivar
        try {
          const { data: responseShared } = await customAxios.get(
            `liveRobotsShared/isAPIActivated/${id}`
          );

          if (responseShared?.message === "0") {
            const del = await customAxios.get(`liveRobotsShared/delete/${id}`);
            if (del.status >= 200 && del.status < 300) {
              // const result = del.data; // si lo necesitas
              setClientShared(false);
            } else {
              setClientShared(true);
            }
          } else {
            handleErrorStrategy("Tienes la estrategia activada en el Conector");
          }
        } catch (error) {
          console.error("error", error);
        }
      }
    } catch (error) {
      console.error(error);
    }

    setTimeout(() => {
      setIsLoading(false);
      if (clientShared === false) {
        dispatch(show({ type: "warning", msg: t("tradingRobots:redirected") }));
        history.push("/tradingrobots/main", { activatedRobotId: id });
      }
    }, 5000);
  };

  return (
    <Menu
      id="customized-menu"
      anchorEl={anchor}
      keepMounted
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      open={Boolean(anchor)}
      onClose={handleClose}
      bgcolor="#253E66"
      PaperProps={{
        sx: {
          borderRadius: "5px",
          backgroundColor: "#253E66",
        },
      }}
      MenuListProps={{
        sx: {
          padding: 0,
        },
      }}
    >
      {/* 🔴 Solo mostramos el conector si showConnector === true */}
      {showConnector && (
        <Box display="flex" alignItems="center" justifyContent="center" px={2}>
          <Switch
            disableRipple
            disableTouchRipple
            sx={{
              "& .MuiSwitch-track": {
                height: 16,
                width: 30,
                borderRadius: "10px",
              },
              "& .MuiSwitch-thumb": {
                color: "white",
                boxShadow: "none",
                height: 12,
                width: 12,
              },
              "& .MuiSwitch-switchBase": {
                top: 5,
                left: 5,
                "&.Mui-disabled": {
                  cursor: "not-allowed ",
                },
                "&.Mui-checked": {
                  left: -1,
                  "& +.MuiSwitch-track": {
                    color: "red",
                    opacity: [1, "!important"],
                  },
                },
              },
            }}
            disabled={isLoading}
            checked={clientShared}
            onChange={handleAPIActivation}
          />
          <Typography color="white" variant="body2">
            {t("ActAPI")}
          </Typography>
        </Box>
      )}

      <ProtectedComponent
        iconTop="-30px"
        iconRight="2px"
        iconSize="20"
        iconColor="grey"
        onItemClick={handleLoad(id, "/builder")}
      >
        <Button variant="text" color="secondary" fullWidth>
          {t("OpenBuilder")}
        </Button>
      </ProtectedComponent>
      <ProtectedComponent
        iconTop="-30px"
        iconRight="2px"
        iconSize="20"
        iconColor="grey"
        onItemClick={handleLoad(id, "/validation")}
      >
        <Button variant="text" color="secondary" fullWidth>
          {t("OpenValidator")}
        </Button>
      </ProtectedComponent>
    </Menu>
  );
};

PopUpMenu.propTypes = {
  id: PropTypes.number.isRequired,
  anchor: PropTypes.objectOf(PropTypes.any).isRequired,
  handleClose: PropTypes.func.isRequired,
  handleLoad: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  handleErrorStrategy: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  shared: PropTypes.bool.isRequired,
  showConnector: PropTypes.bool, // 👈 NUEVO
};

export default PopUpMenu;
